import 'ui-core/plugins/slide/js/slide';

(function (UX) {
    UX.slide.setBackLabel = function () {
        UX.slide.$back.html('<i class="icon-arrow_left" aria-hidden="true"></i>');
    };
    UX.slide.additionalInitialization = function () {
        if ($('.journal-branding').length) {
            $('.w-slide').addClass('journal-branding');
        }
    };
})(UX);
